import React from 'react';
import classes from './Icons.module.css';

export const NotificationIcon = (props) => {
	return (
		<div className={classes.IconContainer}>
			<svg className={classes.Icon} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
			</svg>
		</div>
	)
}

export const HomeIcon = (props) => {
	return (
		<div className={classes.IconContainer}>
			<svg className={classes.Icon} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
			</svg>
		</div>
	)
}

export const BoardIcon = (props) => {
	return (
		<div className={classes.IconContainer}>
			<svg className={classes.Icon} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
			</svg>
		</div>
	)
}


export const UserIcon = (props) => {
	return (
		<div className={classes.IconContainer}>
			<svg className={classes.Icon} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
			</svg>
		</div>
	)
}

export const InfoIcon = (props) => {
	return (
		<div className={classes.IconContainer}>
			<svg className={classes.Icon} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
			</svg>
		</div>
	)
}

export const ADGIcon = (props) => {
	return (
		<div className={classes.ADGIconContainer}>
			<svg className={classes.ADGIcon} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 406 406" xmlns="http://www.w3.org/2000/svg">
				<path d="M127.167 56L308 0L259 95.6667L166.833 119L115.5 194.833L0 199.5L127.167 56Z" fill="currentColor" />
				<path d="M395.139 202.011L348.824 385.565L292.645 293.928L320.698 203.087L282.67 119.782L338.807 18.7343L395.139 202.011Z" fill="currentColor" />
				<path d="M136.785 362.761L1.16643 230.684L108.618 228.001L173.165 297.808L264.311 306.654L323.612 405.876L136.785 362.761Z" fill="currentColor" />
				<path d="M282.333 119L320.833 203L240.333 205.333L282.333 119Z" fill="currentColor" />
				<path d="M211.167 190.166L115.5 194.833L166.833 119L211.167 190.166Z" fill="currentColor" />
				<path d="M263.667 306.833L172.667 297.5L213.5 227.5L263.667 306.833Z" fill="currentColor" />
				<path d="M172.667 297.5L264.833 306.833L323.167 406L136.5 363L172.667 297.5Z" fill="currentColor" />
				<path d="M338.334 19.8333L394.334 200.667L320.834 203L282.333 119L338.334 19.8333Z" fill="currentColor" />
				<path d="M0 199.5L127 56L166.833 119L114.333 194.833L0 199.5Z" fill="currentColor" />
			</svg>
		</div>
	)
}


export const ADGIconColored = (props) => {
	return (
		<div className={classes.ADGIconContainer}>
			<svg className={classes.ADGIconColored} height="30px" width="30px" fill="none" stroke="currentColor" viewBox="0 0 406 406" xmlns="http://www.w3.org/2000/svg">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M127.167 56L308 0L259 95.6667L166.833 119L115.5 194.833L0 199.5L127.167 56Z" fill="#297E3D" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M395.139 202.011L348.824 385.565L292.645 293.928L320.698 203.087L282.67 119.782L338.807 18.7343L395.139 202.011Z" fill="#C5292A" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M136.785 362.761L1.16643 230.684L108.618 228.001L173.165 297.808L264.311 306.654L323.612 405.876L136.785 362.761Z" fill="#FAA821" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M282.333 119L320.833 203L240.333 205.333L282.333 119Z" fill="#C34B4A" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M211.167 190.166L115.5 194.833L166.833 119L211.167 190.166Z" fill="#328E41" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M263.667 306.833L172.667 297.5L213.5 227.5L263.667 306.833Z" fill="#F5BF48" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M172.667 297.5L264.833 306.833L323.167 406L136.5 363L172.667 297.5Z" fill="#F28020" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M338.334 19.8333L394.334 200.667L320.834 203L282.333 119L338.334 19.8333Z" fill="#B62125" />
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M0 199.5L127 56L166.833 119L114.333 194.833L0 199.5Z" fill="#1B5F30" />
			</svg>
		</div>
	)
}